// extracted by mini-css-extract-plugin
module.exports = {"postman":"Postman-module--postman--2vN4Y"};